import React, { useState, useEffect } from 'react';
import styles from './PowerHourBanner.module.css';

export interface PowerHourBannerProps {
  multiplier: number;
  countdown: number;
  className?: string;
}

const PowerHourBanner: React.FC<PowerHourBannerProps> = ({
  multiplier,
  countdown,
  className = '',
}) => {
  const [timeLeft, setTimeLeft] = useState(countdown);

  useEffect(() => {
    // Update time left every second
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev - 1000;
        return newTime <= 0 ? 0 : newTime;
      });
    }, 1000);

    // Cleanup timer on unmount
    return () => clearInterval(timer);
  }, []);

  // Update timeLeft when countdown prop changes
  useEffect(() => {
    setTimeLeft(countdown);
  }, [countdown]);

  const getCountdown = (diff: number) => {
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className={`${styles.bonusPeriodOpenBanner} ${className}`}>
      <div className={styles.borderTop}></div>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/team-voting/lightning.png"
        alt="Power Hour Lightning Bolt"
        width={38}
        height={38}
        className={styles.lightningIcon}
      />
      <span className={styles.powerHourText}>POWER HOUR -&nbsp;</span>
      <span className={styles.bonusPeriodOpenBannerPointsText}>
        ALL POINTS X{multiplier}
      </span>
      <div className={`${styles.countdownText} ${styles.countdownContainer}`}>
        <img
          src="/theme-assets/default/icons/clock.svg"
          alt="Clock"
          width={16}
          height={17}
          style={{ marginRight: '4px' }}
        />
        Ends in {getCountdown(timeLeft)}
      </div>
      <div className={styles.borderBottom}></div>
    </div>
  );
};

export default PowerHourBanner;
